import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDispersion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDispersion"><Path d="M21.4004 19.7998L20.2002 21.4004L14.5996 17.2002L15.7998 15.5996L21.4004 19.7998ZM11 3H13V21H11V3ZM9 15V17H2V15H9ZM9 11V13H2V11H9ZM22 11V13H15V11H22ZM9 7V9H2V7H9ZM21.4004 4.2002L15.7998 8.40039L14.5996 6.7998L20.2002 2.59961L21.4004 4.2002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDispersion;
